import { render, staticRenderFns } from "./previewFile.vue?vue&type=template&id=a33d5e56&"
import script from "./previewFile.vue?vue&type=script&lang=js&"
export * from "./previewFile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.10.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports